import React, { useState } from 'react';

import { Checkbox, Loader, useToaster } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { granetApi } from 'client/api';
import { useSettingsPageContext } from 'client/context/settingsPageContext';
import { useCurrentAliceApp } from 'client/hooks/useCurrentAliceApp';
import { getAccessAsViewer, getCanEditApp, getIsAdmin } from 'client/utils';
import * as keyset from 'i18n/IntentsPage';

interface Props {
    intentId: string;
    isActivationFlag: boolean;
}

const GRAMMAR_FLAG_TOAST = 'GRAMMAR_FLAG_TOAST';
const t = i18n(keyset);

export const GrammarPageFlagsSettings: React.FC<Props> = ({ intentId, isActivationFlag }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [innerChecked, setInnerChecked] = useState(isActivationFlag);

    const { add: toasterAdd } = useToaster();
    const { isDraft } = useSettingsPageContext();
    const skill = useCurrentAliceApp()!;

    const userHasFlag = Boolean(__appConfig.user.featureFlags.allowUseIntentFlags);
    const displayFlags = getAccessAsViewer() || userHasFlag;
    const allowEditFlags = getIsAdmin() || (getCanEditApp(skill) && userHasFlag && isDraft);

    if (!displayFlags) return null;

    const onFlagChange = async (checked: boolean) => {
        setIsLoading(true);
        const prevValue = innerChecked;
        setInnerChecked(checked);
        try {
            await granetApi.patchIntentFlags(intentId, skill.id, skill.channel, { isActivation: checked }, isDraft);
            toasterAdd && toasterAdd({ title: t('changes-saved'), theme: 'success', name: GRAMMAR_FLAG_TOAST });
        } catch (error) {
            console.error('@GrammarPageFlagsSettings', error);
            toasterAdd && toasterAdd({ title: t('error'), theme: 'danger', name: GRAMMAR_FLAG_TOAST });
            setInnerChecked(prevValue);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Checkbox checked={innerChecked} onUpdate={onFlagChange} disabled={!allowEditFlags || isLoading} size="l">
                {t('activation-grammar')}
            </Checkbox>
            {isLoading && <Loader size="s" />}
        </>
    );
};
